export default [
  'bg',
  'wallpaper',
  'fg',
  'text',
  'underlay',
  'link',
  'accent',
  'faint',
  'faintLink',
  'postFaintLink',

  'cBlue',
  'cRed',
  'cGreen',
  'cOrange',

  'profileBg',
  'profileTint',

  'highlight',
  'highlightLightText',
  'highlightPostLink',
  'highlightFaintText',
  'highlightFaintLink',
  'highlightPostFaintLink',
  'highlightText',
  'highlightLink',
  'highlightIcon',

  'popover',
  'popoverLightText',
  'popoverPostLink',
  'popoverFaintText',
  'popoverFaintLink',
  'popoverPostFaintLink',
  'popoverText',
  'popoverLink',
  'popoverIcon',

  'selectedPost',
  'selectedPostFaintText',
  'selectedPostLightText',
  'selectedPostPostLink',
  'selectedPostFaintLink',
  'selectedPostText',
  'selectedPostLink',
  'selectedPostIcon',

  'selectedMenu',
  'selectedMenuLightText',
  'selectedMenuFaintText',
  'selectedMenuFaintLink',
  'selectedMenuText',
  'selectedMenuLink',
  'selectedMenuIcon',

  'selectedMenuPopover',
  'selectedMenuPopoverLightText',
  'selectedMenuPopoverFaintText',
  'selectedMenuPopoverFaintLink',
  'selectedMenuPopoverText',
  'selectedMenuPopoverLink',
  'selectedMenuPopoverIcon',

  'lightText',

  'postLink',

  'postGreentext',

  'postCyantext',

  'border',

  'poll',
  'pollText',

  'icon',

  // Foreground,
  'fgText',
  'fgLink',

  // Panel header,
  'panel',
  'panelText',
  'panelFaint',
  'panelLink',

  // Top bar,
  'topBar',
  'topBarText',
  'topBarLink',

  // Tabs,
  'tab',
  'tabText',
  'tabActiveText',

  // Buttons,
  'btn',
  'btnText',
  'btnPanelText',
  'btnTopBarText',

  // Buttons: pressed,
  'btnPressed',
  'btnPressedText',
  'btnPressedPanel',
  'btnPressedPanelText',
  'btnPressedTopBar',
  'btnPressedTopBarText',

  // Buttons: toggled,
  'btnToggled',
  'btnToggledText',
  'btnToggledPanelText',
  'btnToggledTopBarText',

  // Buttons: disabled,
  'btnDisabled',
  'btnDisabledText',
  'btnDisabledPanelText',
  'btnDisabledTopBarText',

  // Input fields,
  'input',
  'inputText',
  'inputPanelText',
  'inputTopbarText',

  'alertError',
  'alertErrorText',
  'alertErrorPanelText',

  'alertWarning',
  'alertWarningText',
  'alertWarningPanelText',

  'alertSuccess',
  'alertSuccessText',
  'alertSuccessPanelText',

  'alertNeutral',
  'alertNeutralText',
  'alertNeutralPanelText',

  'alertPopupError',
  'alertPopupErrorText',

  'alertPopupWarning',
  'alertPopupWarningText',

  'alertPopupSuccess',
  'alertPopupSuccessText',

  'alertPopupNeutral',
  'alertPopupNeutralText',

  'badgeNeutral',
  'badgeNeutralText',

  'badgeNotification',
  'badgeNotificationText',

  'chatBg',

  'chatMessageIncomingBg',
  'chatMessageIncomingText',
  'chatMessageIncomingLink',
  'chatMessageIncomingBorder',
  'chatMessageOutgoingBg',
  'chatMessageOutgoingText',
  'chatMessageOutgoingLink',
  'chatMessageOutgoingBorder'
]
